export enum ShippingMemberTitle {
    NOVUS = 20,
    ASSISTANTMANAGER = 21,
    SUPERVISOR = 22
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/shipping-member-title.enum.ts